import { ScanMetadata } from '../../interfaces/scanMetadata';

const MAX_SCANS_COUNT = 6;

export type DefaultScanRange = {
  startScanId: number | null;
  endScanId: number | null;
};
/** scansMetadata - sorted by scanDateTime from newest to oldest */
export const getDefaultScansRange = (scansMetadata: ScanMetadata[]): DefaultScanRange => {
  if (scansMetadata.length < 2) {
    return {
      startScanId: null,
      endScanId: null,
    };
  }

  const newestScan = scansMetadata[0];
  const oldestScan = scansMetadata[scansMetadata.length - 1];

  if (scansMetadata.length <= MAX_SCANS_COUNT) {
    return {
      startScanId: oldestScan.scanId,
      endScanId: newestScan.scanId,
    };
  }

  const startScan = scansMetadata[MAX_SCANS_COUNT - 1];

  return {
    startScanId: startScan.scanId,
    endScanId: newestScan.scanId,
  };
};
